import { Table } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

function Jurnal() {
    let [data, setData] = useState([]);
    useEffect(() => {
        axios.get("/logs").then(res => {
            setData(res.data);
        })
    }, [])

    let columns = [
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "Xarakat turi",
            dataIndex: "type",
            key: "type",
        },
        {
            title: "Bajarilgan ish",
            dataIndex: "logtext",
            key: "logtext",
        },
        {
            title: "Foydalanuvchi",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Vaqti",
            dataIndex: "created_at",
            key: "created_at",
        },
    ]
    return (
        <Table columns={columns} size='small' bordered dataSource={data} rowKey="id" />
    );
}

export default Jurnal;